var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifeStyleWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 35,
    viewBox: "0 0 97 35",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lifeStyleWork-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 35,
    transform: "translate(-27.551 1)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lifeStyleWork",
    transform: "translate(27.551 -1)",
    clipPath: "url(#lifeStyleWork-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.38,14.184H2.449V39.6H40.38Z",
    transform: "translate(0 -4.598)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,9.586H15.242V5.793A3.8,3.8,0,0,1,19.035,2H34.208A3.8,3.8,0,0,1,38,5.793Z",
    transform: "translate(-4.828)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.38,28.134l-18.965,4.21L2.449,28.134",
    transform: "translate(0 -9.862)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeStyleWork);
export default __webpack_public_path__ + "static/media/lifeStyleWork.d603fb2b63741948fb61f8cd02422f67.svg";
export { ForwardRef as ReactComponent };